export * from "./auth";
export var InputAction;

(function (InputAction) {
  InputAction[InputAction["ADD"] = 0] = "ADD";
  InputAction[InputAction["DELETE"] = 1] = "DELETE";
})(InputAction || (InputAction = {}));

export var MyAccountTabs;

(function (MyAccountTabs) {
  MyAccountTabs["ACCOUNT_PROFILE"] = "account-profile";
  MyAccountTabs["ORDER_HISTORY"] = "order-history";
  MyAccountTabs["PAYMENT_OPTIONS"] = "express-checkout-settings";
  MyAccountTabs["PREFERRED_LOCATION"] = "preferred-location";
})(MyAccountTabs || (MyAccountTabs = {}));

export var CreditCardFlowSource;

(function (CreditCardFlowSource) {
  CreditCardFlowSource["USER_PROFILE"] = "USER_PROFILE";
  CreditCardFlowSource["PAYMENT"] = "PAYMENT";
})(CreditCardFlowSource || (CreditCardFlowSource = {}));

export var CREDIT_CARD_FORM_FLOW;

(function (CREDIT_CARD_FORM_FLOW) {
  CREDIT_CARD_FORM_FLOW[CREDIT_CARD_FORM_FLOW["ADD"] = 0] = "ADD";
  CREDIT_CARD_FORM_FLOW[CREDIT_CARD_FORM_FLOW["UPDATE"] = 1] = "UPDATE";
  CREDIT_CARD_FORM_FLOW[CREDIT_CARD_FORM_FLOW["DELETE"] = 2] = "DELETE";
})(CREDIT_CARD_FORM_FLOW || (CREDIT_CARD_FORM_FLOW = {}));

export var RSATokenTransactionType;

(function (RSATokenTransactionType) {
  RSATokenTransactionType["PROFILE"] = "ProfileRSAToken";
  RSATokenTransactionType["TOGO"] = "ToGoRSAToken";
  RSATokenTransactionType["MOBILE_PAY"] = "MobilePayRSAToken";
  RSATokenTransactionType["GIFTCARD"] = "GiftCardRSAToken";
})(RSATokenTransactionType || (RSATokenTransactionType = {}));

export var ValidateTokenTransactionType;

(function (ValidateTokenTransactionType) {
  ValidateTokenTransactionType["PROFILE"] = "PROFILE";
  ValidateTokenTransactionType["TOGO"] = "ToGoValidateToken";
  ValidateTokenTransactionType["MOBILE_PAY"] = "MobilePayValidateToken";
  ValidateTokenTransactionType["GIFTCARD"] = "GiftcardValidateToken";
})(ValidateTokenTransactionType || (ValidateTokenTransactionType = {}));